import React, { useState } from "react";
import trans from "../../utils";
import Button from "../Helpers/Button/Button";
import { useNavigate } from "react-router-dom";
import ConfirmationDeletion from "./ConfirmationDeletion";

export default function DeleteAccount() {
	const navigate = useNavigate();
	const [modal, setModal] = useState(false);
	const [email, setEmail] = useState("");
	const [error, setError] = useState("");

	const handleDeleteClick = () => {
		if (!email) {
			setError("Please enter your email");
			return;
		}

		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

		if (!emailRegex.test(email)) {
			setError("Please enter a valid email");
			return;
		}

		setError("");
		setModal(true);
	};

	return (
		<>
			<style>{`
				.delete-account-page {
					max-width: 900px;
				}

				.delete-alert {
					background: #fff5f5;
					border-left: 4px solid #dc3545;
					padding: 20px;
					border-radius: 10px;
					margin-bottom: 24px;
				}

				.delete-alert h4 {
					color: #dc3545;
					margin-bottom: 10px;
					font-weight: 600;
				}

				.delete-section {
					background: #fff;
					border: 1px solid #e9ecef;
					border-radius: 12px;
					padding: 24px;
					margin-bottom: 20px;
				}

				.delete-section h3 {
					font-size: 20px;
					font-weight: 600;
					margin-bottom: 16px;
					color: #222;
				}

				.delete-section p {
					color: #666;
					line-height: 1.8;
					margin-bottom: 12px;
				}

				.delete-steps {
					padding-left: 22px;
				}

				.delete-steps li {
					margin-bottom: 10px;
					line-height: 1.7;
					color: #555;
				}

				.delete-contact {
					background: #f8fffd;
					border: 1px solid #d9f5ee;
					padding: 24px;
					border-radius: 12px;
					margin-bottom: 20px;
				}

				.delete-contact a {
					color: #00a884;
					font-weight: 600;
					text-decoration: none;
				}

				.delete-contact a:hover {
					text-decoration: underline;
				}

				.developer-info {
					display: flex;
					justify-content: space-between;
					align-items: center;
					padding: 16px 20px;
					background: #f8f9fa;
					border-radius: 10px;
					margin-bottom: 24px;
					font-size: 14px;
					color: #666;
				}

				.developer-info strong {
					font-size: 15px;
					color: #222;
				}

				.delete-input {
					width: 100%;
					padding: 12px 14px;
					border: 1px solid #d0d7de;
					border-radius: 10px;
					font-size: 14px;
					margin-top: 10px;
					outline: none;
					transition: 0.2s;
				}

				.delete-input:focus {
					border-color: #00a884;
					box-shadow: 0 0 0 3px rgba(0, 168, 132, 0.15);
				}

				.error-text {
					color: #dc3545;
					font-size: 13px;
					margin-top: 8px;
				}
			`}</style>

			<div className="account-header border-bottom">
				<div className="flex-between">
					<div className="d-block">
						<div className="fs-24 fw-600 text-capitalize">
							{trans("Delete Account")}
						</div>
						<p className="second-header-text">
							{trans(
								"Before you proceed, please take a moment to understand what happens to your data.",
							)}
						</p>
					</div>
				</div>
			</div>

			<div className="account">
				<div className="account-layout delete-account-page">
					<div className="delete-alert">
						<h4>{trans("Important Notice")}</h4>
						<p>
							{trans(
								"Deleting your account is permanent and cannot be undone.",
							)}
						</p>
					</div>

					<div className="delete-section">
						<h3>{trans("Confirm Your Email")}</h3>

						<p>
							{trans(
								"Please enter your account email to confirm deletion.",
							)}
						</p>

						<input
							type="email"
							value={email}
							onChange={(e) => setEmail(e.target.value)}
							placeholder="example@domain.com"
							className="delete-input"
						/>

						{error && <div className="error-text">{error}</div>}
					</div>

					<div className="delete-section">
						<h3>{trans("What Happens When You Delete Your Account?")}</h3>

						<p>
							{trans(
								"All your data, settings, and content will be permanently removed.",
							)}
						</p>

						<p>
							{trans(
								"Your account will be deactivated immediately and deleted within 30 days.",
							)}
						</p>

						<p>
							{trans(
								"Some shared content may remain visible but will not be linked to you.",
							)}
						</p>

						<p>
							{trans(
								"Subscriptions will be cancelled immediately without refund.",
							)}
						</p>
					</div>

					<div className="delete-section">
						<h3>{trans("How to Delete Your Account")}</h3>

						<ol className="delete-steps">
							<li>{trans("Go to Profile Settings")}</li>
							<li>{trans("Select Delete Account")}</li>
							<li>{trans("Confirm deletion")}</li>
							<li>{trans("Account will be scheduled for removal")}</li>
						</ol>
					</div>

					<div className="delete-contact">
						<h3>{trans("Need Help?")}</h3>
						<p>{trans("Contact us at:")}</p>
						<a href="mailto:info@uma-uk.com">info@uma-uk.com</a>
					</div>

					<div className="developer-info">
						<strong>UMA-UK</strong>
						<span>{trans("Service Provider")}</span>
					</div>

					<div className="d-flex align-items-center">
						<Button
							text={trans("Delete Account")}
							type="primary"
							onClick={handleDeleteClick}
						/>
						<Button
							text={trans("Cancel")}
							type="default"
							className="ms-2"
							onClick={() => navigate("/setup/account")}
						/>
					</div>
				</div>
			</div>

			<ConfirmationDeletion modal={modal} setModal={setModal} />
		</>
	);
}